import email from "../assets/email.png";
import mobile from "../assets/mobile.png";

import css from "../assets/css.png";

import git from "../assets/git.png";

import html from "../assets/html.png";
import javascript from "../assets/javascript.png";

import node from "../assets/node.png";

import react from "../assets/react.png";
import redux from "../assets/redux.png";
import sass from "../assets/sass.png";
import typescript from "../assets/typescript.png";

import profile from "../assets/profile.png";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";

export default {
  email,
  mobile,
  css,
  git,
  html,
  javascript,
  node,
  react,
  redux,
  sass,
  typescript,
  profile,
  circle,
  logo,
};
